import { render, staticRenderFns } from "./ColorSelectorMobile.vue?vue&type=template&id=00976740&"
import script from "./ColorSelectorMobile.vue?vue&type=script&lang=js&"
export * from "./ColorSelectorMobile.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelectorMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports